import React from 'react';
import { Outlet } from 'react-router-dom';
import { Result, Spin } from 'antd';
import { HasAccess } from "@permify/react-role";
import { getCookie } from '../services/cookies';
import config from '../config';
import PrivateLayout from './PrivateLayout';

const PrivateRoute = ({ children, roles }) => {
  if (config.env !== "development") {
    if (!getCookie('user') || !getCookie('roles') || !getCookie('branch_office_id')) {
      window.location.href = config.loginRedirect;
      return null;
    }
  }

  return children
    ? (
      <PrivateLayout>
        <HasAccess
          roles={roles}
          renderAuthFailed={<Result
            status="403"
            title="403"
            subTitle="Lo sentimos, no está autorizado a acceder a esta página."
          />}
          isLoading={<Spin />}
        >
          {children}
        </HasAccess>
      </PrivateLayout>
    )
    : <Outlet />;
}

export { PrivateRoute };